import {
    SET_ERROR,
    CORE_AUTH_VERIFY_SUCCESS,
    CORE_AUTH_VERIFY_FAILURE,
    CORE_GET_USERS_REQUEST,
    CORE_GET_USERS_SUCCESS,
    CORE_GET_USERS_FAILURE,
    CORE_GET_MASTERS_REQUEST,
    CORE_GET_MASTERS_SUCCESS,
    CORE_GET_MASTERS_FAILURE,
    CORE_GET_ALL_MYTASKS_REQUEST,
    CORE_GET_ALL_MYTASKS_SUCCESS,
    CORE_GET_ALL_MYTASKS_FAILURE,
    CORE_GET_MYTASK_BY_ID_REQUEST,
    CORE_GET_MYTASK_BY_ID_SUCCESS,
    CORE_GET_MYTASK_BY_ID_FAILURE,
    CORE_CREATE_MYTASK_REQUEST,
    CORE_CREATE_MYTASK_SUCCESS,
    CORE_CREATE_MYTASK_FAILURE,
    CORE_SUBMIT_TASK_REQUEST,
    CORE_SUBMIT_TASK_SUCCESS,
    CORE_SUBMIT_TASK_FAILURE,
    CORE_COMMENT_TASK_REQUEST,
    CORE_COMMENT_TASK_SUCCESS,
    CORE_COMMENT_TASK_FAILURE,
    CORE_GET_ALL_MY_ASSIGN_REQUEST,
    CORE_GET_ALL_MY_ASSIGN_SUCCESS,
    CORE_GET_ALL_MY_ASSIGN_FAILURE,
    CORE_GET_ASSIGN_TASK_BY_ID_REQUEST,
    CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS,
    CORE_GET_ASSIGN_TASK_BY_ID_FAILURE,
    CORE_IN_PROGRESS_TASK_REQUEST,
    CORE_IN_PROGRESS_TASK_SUCCESS,
    CORE_IN_PROGRESS_TASK_FAILURE,
    CORE_GET_ALL_MY_DRAFT_REQUEST,
    CORE_GET_ALL_MY_DRAFT_SUCCESS,
    CORE_GET_ALL_MY_DRAFT_FAILURE,
    CORE_GET_DRAFT_TASK_BY_ID_REQUEST,
    CORE_GET_DRAFT_TASK_BY_ID_SUCCESS,
    CORE_GET_DRAFT_TASK_BY_ID_FAILURE,
    CORE_UPDATE_TASK_REQUEST,
    CORE_UPDATE_TASK_SUCCESS,
    CORE_UPDATE_TASK_FAILURE,
    CORE_WAITING_TEST_ASSIGN_TASK_REQUEST,
    CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS,
    CORE_WAITING_TEST_ASSIGN_TASK_FAILURE,
    CORE_DONE_ASSIGN_TASK_REQUEST,
    CORE_DONE_ASSIGN_TASK_SUCCESS,
    CORE_DONE_ASSIGN_TASK_FAILURE,
    CORE_DISCUSS_ASSIGN_TASK_REQUEST,
    CORE_DISCUSS_ASSIGN_TASK_SUCCESS,
    CORE_DISCUSS_ASSIGN_TASK_FAILURE,
    CORE_ATTACH_TASK_REQUEST,
    CORE_ATTACH_TASK_SUCCESS,
    CORE_ATTACH_TASK_FAILURE,
    CORE_CLOSED_TASK_REQUEST,
    CORE_CLOSED_TASK_SUCCESS,
    CORE_CLOSED_TASK_FAILURE,
    CORE_CANCEL_TASK_REQUEST,
    CORE_CANCEL_TASK_SUCCESS,
    CORE_CANCEL_TASK_FAILURE,
    CORE_REOPEN_TASK_REQUEST,
    CORE_REOPEN_TASK_SUCCESS,
    CORE_REOPEN_TASK_FAILURE,
    CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST,
    CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS,
    CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE,
    CORE_GET_OIL_PRICES_REQUEST,
    CORE_GET_OIL_PRICES_SUCCESS,
    CORE_GET_OIL_PRICES_FAILURE,
    CORE_GET_ALL_COURSE_INCOMING_REQUEST,
    CORE_GET_ALL_COURSE_INCOMING_SUCCESS,
    CORE_GET_ALL_COURSE_INCOMING_FAILURE,
    CORE_GET_ALL_COURSE_HISTORY_REQUEST,
    CORE_GET_ALL_COURSE_HISTORY_SUCCESS,
    CORE_GET_ALL_COURSE_HISTORY_FAILURE,
    CORE_GET_COURSE_BY_ID_INCOMING_REQUEST,
    CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS,
    CORE_GET_COURSE_BY_ID_INCOMING_FAILURE,
    CORE_CREATE_CAR_RESERVE_REQUEST,
    CORE_CREATE_CAR_RESERVE_SUCCESS,
    CORE_CREATE_CAR_RESERVE_FAILURE,
    CORE_UPDATE_CAR_RESERVE_REQUEST,
    CORE_UPDATE_CAR_RESERVE_SUCCESS,
    CORE_UPDATE_CAR_RESERVE_FAILURE,
    CORE_CANCEL_CAR_RESERVE_REQUEST,
    CORE_CANCEL_CAR_RESERVE_SUCCESS,
    CORE_CANCEL_CAR_RESERVE_FAILURE,
    CORE_REJECT_CAR_RESERVE_REQUEST,
    CORE_REJECT_CAR_RESERVE_SUCCESS,
    CORE_REJECT_CAR_RESERVE_FAILURE,
    CORE_START_CAR_DRIVER_REQUEST,
    CORE_START_CAR_DRIVER_SUCCESS,
    CORE_START_CAR_DRIVER_FAILURE,
    CORE_END_CAR_DRIVER_REQUEST,
    CORE_END_CAR_DRIVER_SUCCESS,
    CORE_END_CAR_DRIVER_FAILURE,
    CORE_GET_ALL_MY_CAR_RESERVE_REQUEST,
    CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS,
    CORE_GET_ALL_MY_CAR_RESERVE_FAILURE,
    // CORE_CREATE_PROJECT_REQUEST,
    CORE_CREATE_PROJECT_SUCCESS,
    CORE_CREATE_PROJECT_FAILURE,
    CORE_UPDATE_PROJECT_SUCCESS,
    CORE_UPDATE_PROJECT_FAILURE,
    CORE_GET_PROJECT_REQUEST,
    CORE_GET_PROJECT_SUCCESS,
    CORE_GET_PROJECT_FAILURE
} from '../types';

import {
    CORE_GET_ALL_FLOW_REQUEST,
    CORE_GET_ALL_FLOW_SUCCESS,
    CORE_GET_ALL_FLOW_FAILURE,
    CORE_GET_FLOW_BY_ID_REQUEST,
    CORE_GET_FLOW_BY_ID_SUCCESS,
    CORE_GET_FLOW_BY_ID_FAILURE,
    CORE_CREATE_FLOW_REQUEST,
    CORE_CREATE_FLOW_SUCCESS,
    CORE_CREATE_FLOW_FAILURE,
    CORE_UPDATE_FLOW_REQUEST,
    CORE_UPDATE_FLOW_SUCCESS,
    CORE_UPDATE_FLOW_FAILURE,
    CORE_GET_ALL_USER_GROUP_REQUEST,
    CORE_GET_ALL_USER_GROUP_SUCCESS,
    CORE_GET_ALL_USER_GROUP_FAILURE,
    CORE_GET_USER_GROUP_BY_ID_REQUEST,
    CORE_GET_USER_GROUP_BY_ID_SUCCESS,
    CORE_GET_USER_GROUP_BY_ID_FAILURE,
    CORE_CREATE_USER_GROUP_REQUEST,
    CORE_CREATE_USER_GROUP_SUCCESS,
    CORE_CREATE_USER_GROUP_FAILURE,
    CORE_UPDATE_USER_GROUP_REQUEST,
    CORE_UPDATE_USER_GROUP_SUCCESS,
    CORE_UPDATE_USER_GROUP_FAILURE,
    CORE_DELETE_USER_GROUP_REQUEST,
    CORE_DELETE_USER_GROUP_SUCCESS,
    CORE_DELETE_USER_GROUP_FAILURE,
    CORE_GET_ALL_COURSE_REQUEST,
    CORE_GET_ALL_COURSE_SUCCESS,
    CORE_GET_ALL_COURSE_FAILURE,
    CORE_GET_COURSE_BY_ID_REQUEST,
    CORE_GET_COURSE_BY_ID_SUCCESS,
    CORE_GET_COURSE_BY_ID_FAILURE,
    CORE_CREATE_COURSE_REQUEST,
    CORE_CREATE_COURSE_SUCCESS,
    CORE_CREATE_COURSE_FAILURE,
    CORE_UPDATE_COURSE_REQUEST,
    CORE_UPDATE_COURSE_SUCCESS,
    CORE_UPDATE_COURSE_FAILURE,
    CORE_GET_COURSE_IMAGE_REQUEST,
    CORE_GET_COURSE_IMAGE_SUCCESS,
    CORE_GET_COURSE_IMAGE_FAILURE,
    CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST,
    CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS,
    CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE,
    CORE_APPROVE_COURSE_REQUEST,
    CORE_APPROVE_COURSE_SUCCESS,
    CORE_APPROVE_COURSE_FAILURE,

    // CORE_GET_ALL_COURSE_INCOMING_REQUEST,
    // CORE_GET_ALL_COURSE_INCOMING_SUCCESS,
    // CORE_GET_ALL_COURSE_INCOMING_FAILURE,
    CORE_GET_COURSE_INCOMING_BY_ID_REQUEST,
    CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS,
    CORE_GET_COURSE_INCOMING_BY_ID_FAILURE,
    CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST,
    CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS,
    CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE,
    CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST,
    CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS,
    CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE,
    CORE_ADD_POINT_BY_USER_REQUEST,
    CORE_ADD_POINT_BY_USER_SUCCESS,
    CORE_ADD_POINT_BY_USER_FAILURE,
    CORE_ADD_CERT_BY_USER_REQUEST,
    CORE_ADD_CERT_BY_USER_SUCCESS,
    CORE_ADD_CERT_BY_USER_FAILURE,
    CORE_GET_ALL_COURSE_TYPE_REQUEST,
    CORE_GET_ALL_COURSE_TYPE_SUCCESS,
    CORE_GET_ALL_COURSE_TYPE_FAILURE,
    CORE_GET_COURSE_TYPE_BY_ID_REQUEST,
    CORE_GET_COURSE_TYPE_BY_ID_SUCCESS,
    CORE_GET_COURSE_TYPE_BY_ID_FAILURE,
    CORE_CREATE_COURSE_TYPE_REQUEST,
    CORE_CREATE_COURSE_TYPE_SUCCESS,
    CORE_CREATE_COURSE_TYPE_FAILURE,
    CORE_UPDATE_COURSE_TYPE_REQUEST,
    CORE_UPDATE_COURSE_TYPE_SUCCESS,
    CORE_UPDATE_COURSE_TYPE_FAILURE,
    CORE_ADD_ATTACH_FILE_REQUEST,
    CORE_ADD_ATTACH_FILE_SUCCESS,
    CORE_ADD_ATTACH_FILE_FAILURE,
    CORE_CANCEL_COURSE_REQUEST,
    CORE_CANCEL_COURSE_SUCCESS,
    CORE_CANCEL_COURSE_FAILURE,
    CORE_GET_ALL_CUSTOMER_REQUEST,
    CORE_GET_ALL_CUSTOMER_SUCCESS,
    CORE_GET_ALL_CUSTOMER_FAILURE,
    CORE_GET_CUSTOMER_BY_ID_REQUEST,
    CORE_GET_CUSTOMER_BY_ID_SUCCESS,
    CORE_GET_CUSTOMER_BY_ID_FAILURE,
    CORE_CREATE_CUSTOMER_REQUEST,
    CORE_CREATE_CUSTOMER_SUCCESS,
    CORE_CREATE_CUSTOMER_FAILURE,
    CORE_UPDATE_CUSTOMER_REQUEST,
    CORE_UPDATE_CUSTOMER_SUCCESS,
    CORE_UPDATE_CUSTOMER_FAILURE
} from '../settingsType';

import {
    CORE_GET_ALL_CAR_TYPE_REQUEST,
    CORE_GET_ALL_CAR_TYPE_SUCCESS,
    CORE_GET_ALL_CAR_TYPE_FAILURE,
    CORE_GET_MASTER_CAR_TYPE_REQUEST,
    CORE_GET_MASTER_CAR_TYPE_SUCCESS,
    CORE_GET_MASTER_CAR_TYPE_FAILURE,
    CORE_CREATE_CAR_TYPE_REQUEST,
    CORE_CREATE_CAR_TYPE_SUCCESS,
    CORE_CREATE_CAR_TYPE_FAILURE,
    CORE_UPDATE_CAR_TYPE_REQUEST,
    CORE_UPDATE_CAR_TYPE_SUCCESS,
    CORE_UPDATE_CAR_TYPE_FAILURE,
    CORE_CREATE_CAR_REQUEST,
    CORE_CREATE_CAR_SUCCESS,
    CORE_CREATE_CAR_FAILURE,
    CORE_GET_ALL_CAR_DRIVER_REQUEST,
    CORE_GET_ALL_CAR_DRIVER_SUCCESS,
    CORE_GET_ALL_CAR_DRIVER_FAILURE,
    CORE_UPDATE_CAR_DRIVER_REQUEST,
    CORE_UPDATE_CAR_DRIVER_SUCCESS,
    CORE_UPDATE_CAR_DRIVER_FAILURE,
    CORE_UPDATE_ACTIVE_CAR_REQUEST,
    CORE_UPDATE_ACTIVE_CAR_SUCCESS,
    CORE_UPDATE_ACTIVE_CAR_FAILURE,
    CORE_UPDATE_CAR_REQUEST,
    CORE_UPDATE_CAR_SUCCESS,
    CORE_UPDATE_CAR_FAILURE,
    CORE_GET_ALL_MY_JOB_DRIVER_REQUEST,
    CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS,
    CORE_GET_ALL_MY_JOB_DRIVER_FAILURE
} from '../carReservationType';

const initialStateCallAPI = {
        isLoading: false,

        hasError: false,
        errorMessage: '',
        errorCode: '',
        statusText: ''
    },
    initialStateArray = [];

export default {
    errorList: (state = initialStateArray, action) => {
        switch (action.type) {
            case SET_ERROR:
                let newError = [];
                if (action && Array.isArray(action.error)) {
                    newError = action.error;
                }
                return newError;
            case CORE_AUTH_VERIFY_SUCCESS:
            case CORE_GET_MASTERS_SUCCESS:
            case CORE_GET_ALL_MYTASKS_SUCCESS:
            case CORE_GET_MYTASK_BY_ID_SUCCESS:
            case CORE_CREATE_MYTASK_SUCCESS:
            case CORE_SUBMIT_TASK_SUCCESS:
            case CORE_COMMENT_TASK_SUCCESS:
            case CORE_GET_ALL_MY_ASSIGN_SUCCESS:
            case CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS:
            case CORE_IN_PROGRESS_TASK_SUCCESS:
            case CORE_GET_ALL_MY_DRAFT_SUCCESS:
            case CORE_GET_DRAFT_TASK_BY_ID_SUCCESS:
            case CORE_UPDATE_TASK_SUCCESS:
            case CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS:
            case CORE_DONE_ASSIGN_TASK_SUCCESS:
            case CORE_DISCUSS_ASSIGN_TASK_SUCCESS:
            case CORE_ATTACH_TASK_SUCCESS:
            case CORE_CLOSED_TASK_SUCCESS:
            case CORE_CANCEL_TASK_SUCCESS:
            case CORE_REOPEN_TASK_SUCCESS:
            case CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS:
            case CORE_GET_OIL_PRICES_SUCCESS:
            case CORE_GET_ALL_FLOW_SUCCESS:
            case CORE_GET_FLOW_BY_ID_SUCCESS:
            case CORE_CREATE_FLOW_SUCCESS:
            case CORE_UPDATE_FLOW_SUCCESS:
            case CORE_GET_ALL_USER_GROUP_SUCCESS:
            case CORE_GET_USER_GROUP_BY_ID_SUCCESS:
            case CORE_CREATE_USER_GROUP_SUCCESS:
            case CORE_UPDATE_USER_GROUP_SUCCESS:
            case CORE_DELETE_USER_GROUP_SUCCESS:
            case CORE_GET_ALL_COURSE_SUCCESS:
            case CORE_GET_COURSE_BY_ID_SUCCESS:
            case CORE_CREATE_COURSE_SUCCESS:
            case CORE_UPDATE_COURSE_SUCCESS:
            case CORE_GET_COURSE_IMAGE_SUCCESS:
            case CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS:
            case CORE_APPROVE_COURSE_SUCCESS:
            case CORE_GET_ALL_COURSE_INCOMING_SUCCESS:
            case CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS:
            case CORE_ADD_POINT_BY_USER_SUCCESS:
            case CORE_ADD_CERT_BY_USER_SUCCESS:
            case CORE_GET_ALL_COURSE_TYPE_SUCCESS:
            case CORE_GET_COURSE_TYPE_BY_ID_SUCCESS:
            case CORE_CREATE_COURSE_TYPE_SUCCESS:
            case CORE_UPDATE_COURSE_TYPE_SUCCESS:
            case CORE_GET_ALL_COURSE_HISTORY_SUCCESS:
            case CORE_ADD_ATTACH_FILE_SUCCESS:
            case CORE_CANCEL_COURSE_SUCCESS:
            case CORE_GET_ALL_CAR_TYPE_SUCCESS:
            case CORE_GET_MASTER_CAR_TYPE_SUCCESS:
            case CORE_CREATE_CAR_TYPE_SUCCESS:
            case CORE_UPDATE_CAR_TYPE_SUCCESS:
            case CORE_CREATE_CAR_SUCCESS:
            case CORE_GET_ALL_CAR_DRIVER_SUCCESS:
            case CORE_UPDATE_CAR_DRIVER_SUCCESS:
            case CORE_CREATE_CAR_RESERVE_SUCCESS:
            case CORE_UPDATE_CAR_RESERVE_SUCCESS:
            case CORE_CANCEL_CAR_RESERVE_SUCCESS:
            case CORE_REJECT_CAR_RESERVE_SUCCESS:
            case CORE_START_CAR_DRIVER_SUCCESS:
            case CORE_END_CAR_DRIVER_SUCCESS:
            case CORE_UPDATE_ACTIVE_CAR_SUCCESS:
            case CORE_CREATE_PROJECT_SUCCESS:
            case CORE_UPDATE_PROJECT_SUCCESS:
            case CORE_GET_PROJECT_SUCCESS:
                // if (action && typeof action.payload === 'object') {
                // 	let newError = []
                // 	newError.push({ code: "404", message: "test", isShow: true, isFromAction: true })
                // 	newError.push({ code: "404", message: "ระบบเป็นอะไรไม่รู้ บ้า เล่นอะไรไม่เอาไม่ดี", isShow: true, isFromAction: true })
                // 	newError.push({ code: "404", message: "ลองดูอีกทีได้ไหม เริ่มต้นอีกทีได้ไหม แล้วฉันจะเป็นอย่างไร ใครจะรู้", isShow: true, isFromAction: true })
                // 	newError.push({ code: "404", message: "ลองดูอีกทีได้ไหม เริ่มต้นอีกทีได้ไหม แล้วฉันจะเป็นอย่างไร ใครจะรู้", isShow: true, isFromAction: true })
                // 	newError.push({ code: "404", message: "ลองดูอีกทีได้ไหม เริ่มต้นอีกทีได้ไหม แล้วฉันจะเป็นอย่างไร ใครจะรู้", isShow: true, isFromAction: true })
                // 	return newError
                // }
                if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { errors, result } = action.payload;
                    const { url } = action;
                    let newError = [];
                    if (!result) {
                        if (Array.isArray(errors)) {
                            errors.map((e) => {
                                const { path, code, message } = e;
                                return newError.push({
                                    code,
                                    message,
                                    isShow: true,
                                    path,
                                    url,
                                    isFromAction: true
                                });
                            });
                        } else if (errors && errors.axError) {
                            if (Array.isArray(errors.errors)) {
                                errors.errors.map((e) => {
                                    const { path, message } = e;
                                    return newError.push({
                                        code: 'Please Contact AX Admin',
                                        message,
                                        isShow: true,
                                        isAxError: true,
                                        path,
                                        url,
                                        isFromAction: true
                                    });
                                });
                            } else
                                newError.push({
                                    code: 'Please Contact AX Admin',
                                    message: errors.errors,
                                    isShow: true,
                                    isAxError: true,
                                    path: '',
                                    url,
                                    isFromAction: true
                                });
                        } else
                            newError.push({
                                code: 'unknow',
                                message: 'Some thing went wrong',
                                isShow: true,
                                path: '',
                                url,
                                isFromAction: true
                            });
                    }
                    console.log('newErroo', newError);
                    return newError;
                }
                return state;
            case CORE_AUTH_VERIFY_FAILURE:
            case CORE_GET_MASTERS_FAILURE:
            case CORE_GET_ALL_MYTASKS_FAILURE:
            case CORE_GET_MYTASK_BY_ID_FAILURE:
            case CORE_CREATE_MYTASK_FAILURE:
            case CORE_SUBMIT_TASK_FAILURE:
            case CORE_COMMENT_TASK_FAILURE:
            case CORE_GET_ALL_MY_ASSIGN_FAILURE:
            case CORE_GET_ASSIGN_TASK_BY_ID_FAILURE:
            case CORE_IN_PROGRESS_TASK_FAILURE:
            case CORE_GET_ALL_MY_DRAFT_FAILURE:
            case CORE_GET_DRAFT_TASK_BY_ID_FAILURE:
            case CORE_UPDATE_TASK_FAILURE:
            case CORE_WAITING_TEST_ASSIGN_TASK_FAILURE:
            case CORE_DONE_ASSIGN_TASK_FAILURE:
            case CORE_DISCUSS_ASSIGN_TASK_FAILURE:
            case CORE_ATTACH_TASK_FAILURE:
            case CORE_CLOSED_TASK_FAILURE:
            case CORE_CANCEL_TASK_FAILURE:
            case CORE_REOPEN_TASK_FAILURE:
            case CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE:
            case CORE_GET_OIL_PRICES_FAILURE:
            case CORE_GET_ALL_FLOW_FAILURE:
            case CORE_GET_FLOW_BY_ID_FAILURE:
            case CORE_CREATE_FLOW_FAILURE:
            case CORE_UPDATE_FLOW_FAILURE:
            case CORE_GET_ALL_USER_GROUP_FAILURE:
            case CORE_GET_USER_GROUP_BY_ID_FAILURE:
            case CORE_CREATE_USER_GROUP_FAILURE:
            case CORE_UPDATE_USER_GROUP_FAILURE:
            case CORE_DELETE_USER_GROUP_FAILURE:
            case CORE_GET_ALL_COURSE_FAILURE:
            case CORE_GET_COURSE_BY_ID_FAILURE:
            case CORE_CREATE_COURSE_FAILURE:
            case CORE_UPDATE_COURSE_FAILURE:
            case CORE_GET_COURSE_IMAGE_FAILURE:
            case CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE:
            case CORE_APPROVE_COURSE_FAILURE:
            case CORE_GET_ALL_COURSE_INCOMING_FAILURE:
            case CORE_GET_COURSE_INCOMING_BY_ID_FAILURE:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE:
            case CORE_ADD_POINT_BY_USER_FAILURE:
            case CORE_ADD_CERT_BY_USER_FAILURE:
            case CORE_GET_ALL_COURSE_TYPE_FAILURE:
            case CORE_GET_COURSE_TYPE_BY_ID_FAILURE:
            case CORE_CREATE_COURSE_TYPE_FAILURE:
            case CORE_UPDATE_COURSE_TYPE_FAILURE:
            case CORE_GET_ALL_COURSE_HISTORY_FAILURE:
            case CORE_ADD_ATTACH_FILE_FAILURE:
            case CORE_CANCEL_COURSE_FAILURE:
            case CORE_GET_ALL_CAR_TYPE_FAILURE:
            case CORE_GET_MASTER_CAR_TYPE_FAILURE:
            case CORE_CREATE_CAR_TYPE_FAILURE:
            case CORE_UPDATE_CAR_TYPE_FAILURE:
            case CORE_CREATE_CAR_FAILURE:
            case CORE_GET_ALL_CAR_DRIVER_FAILURE:
            case CORE_UPDATE_CAR_DRIVER_FAILURE:
            case CORE_CREATE_CAR_RESERVE_FAILURE:
            case CORE_UPDATE_CAR_RESERVE_FAILURE:
            case CORE_CANCEL_CAR_RESERVE_FAILURE:
            case CORE_REJECT_CAR_RESERVE_FAILURE:
            case CORE_START_CAR_DRIVER_FAILURE:
            case CORE_END_CAR_DRIVER_FAILURE:
            case CORE_UPDATE_ACTIVE_CAR_FAILURE:
            case CORE_CREATE_PROJECT_FAILURE:
            case CORE_UPDATE_PROJECT_FAILURE:
            case CORE_GET_PROJECT_FAILURE:
                if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { code, message, statusText, statusCode } = action.payload;
                    console.log(action);
                    const { url } = action;
                    let newError = [];

                    newError.push({
                        code: code ? code : statusCode ? statusCode : '404',
                        message: message ? message : statusText ? statusText : 'unknow',
                        isShow: false,
                        statusText,
                        statusCode,
                        url
                    });

                    return newError;
                }
                return state;
            default:
                return state;
        }
    },
    isLoading: (state = false, action) => {
        switch (action.type) {
            // 	case CORE_GET_ALL_TRANSFERS_REQUEST:
            case CORE_GET_MASTERS_REQUEST:
            case CORE_GET_ALL_MYTASKS_REQUEST:
            case CORE_GET_MYTASK_BY_ID_REQUEST:
            case CORE_CREATE_MYTASK_REQUEST:
            case CORE_SUBMIT_TASK_REQUEST:
            case CORE_COMMENT_TASK_REQUEST:
            case CORE_GET_ALL_MY_ASSIGN_REQUEST:
            case CORE_GET_ASSIGN_TASK_BY_ID_REQUEST:
            case CORE_IN_PROGRESS_TASK_REQUEST:
            case CORE_GET_ALL_MY_DRAFT_REQUEST:
            case CORE_GET_DRAFT_TASK_BY_ID_REQUEST:
            case CORE_UPDATE_TASK_REQUEST:
            case CORE_WAITING_TEST_ASSIGN_TASK_REQUEST:
            case CORE_DONE_ASSIGN_TASK_REQUEST:
            case CORE_DISCUSS_ASSIGN_TASK_REQUEST:
            case CORE_ATTACH_TASK_REQUEST:
            case CORE_CLOSED_TASK_REQUEST:
            case CORE_CANCEL_TASK_REQUEST:
            case CORE_REOPEN_TASK_REQUEST:
            case CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST:
            case CORE_GET_OIL_PRICES_REQUEST:
            case CORE_GET_USERS_REQUEST:
            case CORE_GET_ALL_FLOW_REQUEST:
            case CORE_GET_FLOW_BY_ID_REQUEST:
            case CORE_CREATE_FLOW_REQUEST:
            case CORE_UPDATE_FLOW_REQUEST:
            case CORE_GET_ALL_USER_GROUP_REQUEST:
            case CORE_GET_USER_GROUP_BY_ID_REQUEST:
            case CORE_CREATE_USER_GROUP_REQUEST:
            case CORE_UPDATE_USER_GROUP_REQUEST:
            case CORE_DELETE_USER_GROUP_REQUEST:
            case CORE_GET_ALL_COURSE_REQUEST:
            case CORE_GET_COURSE_BY_ID_REQUEST:
            case CORE_CREATE_COURSE_REQUEST:
            case CORE_UPDATE_COURSE_REQUEST:
            case CORE_GET_COURSE_IMAGE_REQUEST:
            case CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST:
            case CORE_APPROVE_COURSE_REQUEST:
            case CORE_GET_ALL_COURSE_INCOMING_REQUEST:
            case CORE_GET_COURSE_INCOMING_BY_ID_REQUEST:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST:
            case CORE_ADD_POINT_BY_USER_REQUEST:
            case CORE_ADD_CERT_BY_USER_REQUEST:
            case CORE_GET_ALL_COURSE_TYPE_REQUEST:
            case CORE_GET_COURSE_TYPE_BY_ID_REQUEST:
            case CORE_CREATE_COURSE_TYPE_REQUEST:
            case CORE_UPDATE_COURSE_TYPE_REQUEST:
            case CORE_GET_ALL_CAR_TYPE_REQUEST:
            case CORE_GET_MASTER_CAR_TYPE_REQUEST:
            case CORE_CREATE_CAR_TYPE_REQUEST:
            case CORE_UPDATE_CAR_TYPE_REQUEST:
            case CORE_CREATE_CAR_REQUEST:
            case CORE_GET_ALL_CAR_DRIVER_REQUEST:
            case CORE_UPDATE_CAR_DRIVER_REQUEST:
            case CORE_GET_ALL_COURSE_HISTORY_REQUEST:
            case CORE_GET_COURSE_BY_ID_INCOMING_REQUEST:
            case CORE_CREATE_CAR_RESERVE_REQUEST:
            case CORE_UPDATE_CAR_RESERVE_REQUEST:
            case CORE_CANCEL_CAR_RESERVE_REQUEST:
            case CORE_REJECT_CAR_RESERVE_REQUEST:
            case CORE_START_CAR_DRIVER_REQUEST:
            case CORE_END_CAR_DRIVER_REQUEST:
            case CORE_ADD_ATTACH_FILE_REQUEST:
            case CORE_CANCEL_COURSE_REQUEST:
            case CORE_UPDATE_ACTIVE_CAR_REQUEST:
            case CORE_GET_ALL_MY_CAR_RESERVE_REQUEST:
            case CORE_GET_ALL_CUSTOMER_REQUEST:
            case CORE_GET_CUSTOMER_BY_ID_REQUEST:
            case CORE_CREATE_CUSTOMER_REQUEST:
            case CORE_UPDATE_CUSTOMER_REQUEST:
            case CORE_UPDATE_CAR_REQUEST:
            case CORE_GET_ALL_MYTASKS_REQUEST:
            case CORE_GET_ALL_MY_JOB_DRIVER_REQUEST:
                return true;
            // 	case CORE_GET_ALL_TRANSFERS_SUCCESS:
            case CORE_GET_MASTERS_SUCCESS:
            case CORE_GET_ALL_MYTASKS_SUCCESS:
            case CORE_GET_MYTASK_BY_ID_SUCCESS:
            case CORE_CREATE_MYTASK_SUCCESS:
            case CORE_SUBMIT_TASK_SUCCESS:
            case CORE_COMMENT_TASK_SUCCESS:
            case CORE_GET_ALL_MY_ASSIGN_SUCCESS:
            case CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS:
            case CORE_IN_PROGRESS_TASK_SUCCESS:
            case CORE_GET_ALL_MY_DRAFT_SUCCESS:
            case CORE_GET_DRAFT_TASK_BY_ID_SUCCESS:
            case CORE_UPDATE_TASK_SUCCESS:
            case CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS:
            case CORE_DONE_ASSIGN_TASK_SUCCESS:
            case CORE_DISCUSS_ASSIGN_TASK_SUCCESS:
            case CORE_ATTACH_TASK_SUCCESS:
            case CORE_CLOSED_TASK_SUCCESS:
            case CORE_CANCEL_TASK_SUCCESS:
            case CORE_REOPEN_TASK_SUCCESS:
            case CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS:
            case CORE_GET_OIL_PRICES_SUCCESS:
            case CORE_GET_USERS_SUCCESS:
            case CORE_GET_ALL_FLOW_SUCCESS:
            case CORE_GET_FLOW_BY_ID_SUCCESS:
            case CORE_CREATE_FLOW_SUCCESS:
            case CORE_UPDATE_FLOW_SUCCESS:
            case CORE_GET_ALL_USER_GROUP_SUCCESS:
            case CORE_GET_USER_GROUP_BY_ID_SUCCESS:
            case CORE_CREATE_USER_GROUP_SUCCESS:
            case CORE_UPDATE_USER_GROUP_SUCCESS:
            case CORE_DELETE_USER_GROUP_SUCCESS:
            case CORE_GET_ALL_COURSE_SUCCESS:
            case CORE_GET_COURSE_BY_ID_SUCCESS:
            case CORE_CREATE_COURSE_SUCCESS:
            case CORE_UPDATE_COURSE_SUCCESS:
            case CORE_GET_COURSE_IMAGE_SUCCESS:
            case CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS:
            case CORE_APPROVE_COURSE_SUCCESS:
            case CORE_GET_ALL_COURSE_INCOMING_SUCCESS:
            case CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS:
            case CORE_ADD_POINT_BY_USER_SUCCESS:
            case CORE_ADD_CERT_BY_USER_SUCCESS:
            case CORE_GET_ALL_COURSE_TYPE_SUCCESS:
            case CORE_GET_COURSE_TYPE_BY_ID_SUCCESS:
            case CORE_CREATE_COURSE_TYPE_SUCCESS:
            case CORE_UPDATE_COURSE_TYPE_SUCCESS:
            case CORE_GET_ALL_CAR_TYPE_SUCCESS:
            case CORE_GET_MASTER_CAR_TYPE_SUCCESS:
            case CORE_CREATE_CAR_TYPE_SUCCESS:
            case CORE_UPDATE_CAR_TYPE_SUCCESS:
            case CORE_CREATE_CAR_SUCCESS:
            case CORE_GET_ALL_CAR_DRIVER_SUCCESS:
            case CORE_UPDATE_CAR_DRIVER_SUCCESS:
            case CORE_GET_ALL_COURSE_HISTORY_SUCCESS:
            case CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS:
            case CORE_CREATE_CAR_RESERVE_SUCCESS:
            case CORE_UPDATE_CAR_RESERVE_SUCCESS:
            case CORE_CANCEL_CAR_RESERVE_SUCCESS:
            case CORE_REJECT_CAR_RESERVE_SUCCESS:
            case CORE_START_CAR_DRIVER_SUCCESS:
            case CORE_END_CAR_DRIVER_SUCCESS:
            case CORE_ADD_ATTACH_FILE_SUCCESS:
            case CORE_CANCEL_COURSE_SUCCESS:
            case CORE_UPDATE_ACTIVE_CAR_SUCCESS:
            case CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS:
            case CORE_GET_ALL_CUSTOMER_SUCCESS:
            case CORE_GET_CUSTOMER_BY_ID_SUCCESS:
            case CORE_CREATE_CUSTOMER_SUCCESS:
            case CORE_UPDATE_CUSTOMER_SUCCESS:
            case CORE_UPDATE_CAR_SUCCESS:
            case CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS:
                return false;
            // 	case CORE_GET_ALL_TRANSFERS_FAILURE:
            case CORE_GET_MASTERS_FAILURE:
            case CORE_GET_ALL_MYTASKS_FAILURE:
            case CORE_GET_MYTASK_BY_ID_FAILURE:
            case CORE_CREATE_MYTASK_FAILURE:
            case CORE_SUBMIT_TASK_FAILURE:
            case CORE_COMMENT_TASK_FAILURE:
            case CORE_GET_ALL_MY_ASSIGN_FAILURE:
            case CORE_GET_ASSIGN_TASK_BY_ID_FAILURE:
            case CORE_IN_PROGRESS_TASK_FAILURE:
            case CORE_GET_ALL_MY_DRAFT_FAILURE:
            case CORE_GET_DRAFT_TASK_BY_ID_FAILURE:
            case CORE_UPDATE_TASK_FAILURE:
            case CORE_WAITING_TEST_ASSIGN_TASK_FAILURE:
            case CORE_DONE_ASSIGN_TASK_FAILURE:
            case CORE_DISCUSS_ASSIGN_TASK_FAILURE:
            case CORE_ATTACH_TASK_FAILURE:
            case CORE_CLOSED_TASK_FAILURE:
            case CORE_CANCEL_TASK_FAILURE:
            case CORE_REOPEN_TASK_FAILURE:
            case CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE:
            case CORE_GET_OIL_PRICES_FAILURE:
            case CORE_GET_USERS_FAILURE:
            case CORE_GET_ALL_FLOW_FAILURE:
            case CORE_GET_FLOW_BY_ID_FAILURE:
            case CORE_CREATE_FLOW_FAILURE:
            case CORE_UPDATE_FLOW_FAILURE:
            case CORE_GET_ALL_USER_GROUP_FAILURE:
            case CORE_GET_USER_GROUP_BY_ID_FAILURE:
            case CORE_CREATE_USER_GROUP_FAILURE:
            case CORE_UPDATE_USER_GROUP_FAILURE:
            case CORE_DELETE_USER_GROUP_FAILURE:

            case CORE_GET_ALL_COURSE_FAILURE:
            case CORE_GET_COURSE_BY_ID_FAILURE:
            case CORE_CREATE_COURSE_FAILURE:
            case CORE_UPDATE_COURSE_FAILURE:
            case CORE_GET_COURSE_IMAGE_FAILURE:
            case CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE:
            case CORE_APPROVE_COURSE_FAILURE:
            case CORE_GET_ALL_COURSE_INCOMING_FAILURE:
            case CORE_GET_COURSE_INCOMING_BY_ID_FAILURE:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE:
            case CORE_ADD_POINT_BY_USER_FAILURE:
            case CORE_ADD_CERT_BY_USER_FAILURE:
            case CORE_GET_ALL_COURSE_TYPE_FAILURE:
            case CORE_GET_COURSE_TYPE_BY_ID_FAILURE:
            case CORE_CREATE_COURSE_TYPE_FAILURE:
            case CORE_UPDATE_COURSE_TYPE_FAILURE:
            case CORE_GET_ALL_CAR_TYPE_FAILURE:
            case CORE_GET_MASTER_CAR_TYPE_FAILURE:
            case CORE_CREATE_CAR_TYPE_FAILURE:
            case CORE_UPDATE_CAR_TYPE_FAILURE:
            case CORE_CREATE_CAR_FAILURE:
            case CORE_GET_ALL_CAR_DRIVER_FAILURE:
            case CORE_UPDATE_CAR_DRIVER_FAILURE:
            case CORE_GET_ALL_COURSE_HISTORY_FAILURE:
            case CORE_GET_COURSE_BY_ID_INCOMING_FAILURE:
            case CORE_CREATE_CAR_RESERVE_FAILURE:
            case CORE_UPDATE_CAR_RESERVE_FAILURE:
            case CORE_CANCEL_CAR_RESERVE_FAILURE:
            case CORE_REJECT_CAR_RESERVE_FAILURE:
            case CORE_START_CAR_DRIVER_FAILURE:
            case CORE_END_CAR_DRIVER_FAILURE:
            case CORE_ADD_ATTACH_FILE_FAILURE:
            case CORE_CANCEL_COURSE_FAILURE:
            case CORE_UPDATE_ACTIVE_CAR_FAILURE:
            case CORE_GET_ALL_MY_CAR_RESERVE_FAILURE:
            case CORE_GET_ALL_CUSTOMER_FAILURE:
            case CORE_GET_CUSTOMER_BY_ID_FAILURE:
            case CORE_CREATE_CUSTOMER_FAILURE:
            case CORE_GET_PROJECT_REQUEST:
            case CORE_UPDATE_CUSTOMER_FAILURE:
            case CORE_UPDATE_CAR_FAILURE:
            case CORE_GET_ALL_MY_JOB_DRIVER_FAILURE:
                return false;
            default:
                return state;
        }
    },
    reducerCallAPI: (state = initialStateCallAPI, action) => {
        switch (action.type) {
            default:
                return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerCallAPI.js